import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReadingDream = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "bed-single-02 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M29.3333 22.6719H2.66667",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M29.3333 28V18.6667C29.3333 17.1939 28.1395 16 26.6667 16H5.33333C3.86057 16 2.66667 17.1939 2.66667 18.6667V28",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M4.66668 16L4.66667 8.67289C4.66667 8.30471 4.96515 8.00623 5.33333 8.00623H7.77101C8.76284 8.00623 9.64644 7.42992 10.2942 6.67887C11.4044 5.39173 13.2462 4.13628 15.9924 4C18.7252 4.12097 20.5844 5.38664 21.7037 6.68028C22.3528 7.43031 23.2372 8.00623 24.2291 8.00623H26.6667C27.0349 8.00623 27.3333 8.30471 27.3333 8.67289V16",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M21.3333 16V13.7453C21.3333 13.4928 21.1913 13.2628 20.9599 13.1617C20.1352 12.8016 18.0676 12 16 12C13.9324 12 11.8647 12.8016 11.0401 13.1617C10.8087 13.2628 10.6667 13.4928 10.6667 13.7453V16",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgReadingDream;
